import React, { useEffect, useState } from 'react';
import { Layout, Menu, Input, Table, Button, Skeleton, Steps, Card, Typography, message, Modal, Form, Row, Col, Spin, Collapse, Space, notification } from 'antd';
import { SearchOutlined, MailOutlined, LoadingOutlined } from '@ant-design/icons';
import { getApprovals, getapproved, getRejected, getProcessParamJson, getProcessParamData } from '../../services/generic';
import { useHistory } from "react-router";
import { Link } from 'react-router-dom';
import ProcessField from '../recordWindow/ProcessField';
import RecordTable from '../recordWindow/RecordTable';
import useDebounce from "../../lib/hooks/useDebounce";
import { Scrollbars } from "react-custom-scrollbars";
import dayjs from "dayjs";

const { Panel } = Collapse;


const { Sider, Content } = Layout;
const { Step } = Steps;
const { Title, Text } = Typography;

const ApprovalWorkflowUI = () => {
  const [selectedInboxItem, setSelectedInboxItem] = useState();
  const [approvlData, setApprovlData] = useState()
  const [tableColumns, setTableColumns] = useState([]);
  const [commentText, setCommentText] = useState(null)
  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [currentStep, setCurrentStep] = useState()
  const [url, setUrl] = useState(null);
  const [selectedMenu, setSelectedMenu] = useState()
  const [searchQuery, setSearchQuery] = useState('');
  const [messageWithoutTable, setMessageWithoutTable] = useState('');
  const [isProcessModalVisible, setIsProcessModalVisible] = useState(false);
  const [processParams, setProcessParams] = useState([]);
  const [formLineFields, setFormLineFields] = useState([]);
  const [processParamsData, setProcessParamsData] = useState({});
  const [loadingProcess, setLoadingProcess] = useState(false);
  const [processTitle, setProcessTitle] = useState("");
  const [selectedRecordsData, setSelectedRecordsData] = useState({});
  const [searchInputs, setSearchInputs] = useState({});
  const debouncedSearchInputs = useDebounce(searchInputs, 500);
  const [displayedData, setDisplayedData] = useState({});
  const [loadingModal, setLoadingModal] = useState(false);
  const [reload, setReload] = useState(false);
  const batchSize = 30;

  const [form] = Form.useForm();
  const history = useHistory();
  console.log(approvlData)
  console.log(processParamsData, processParams)
  const filteredApprovals = Array.isArray(approvlData)
    ? approvlData.filter(item =>
      item?.title?.toLowerCase().includes(searchQuery.toLowerCase())
    )
    : [];


  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  useEffect(() => {
    const fetchData = async () => {
      const approvals = await getApprovals();
      const approvalsData = JSON.parse(approvals); // Parse the JSON string
      const workflowDetails = approvalsData["workflow_details - "]; // Access the array with bracket notation
      console.log(workflowDetails)
      // Set the data to state
      setApprovlData(workflowDetails);
      setSelectedInboxItem(workflowDetails[0])
      setSelectedMenu(workflowDetails[0]?.cwf_workflow_approvals_id)
      setLoading(false)
    }
    fetchData();
  }, [])

  useEffect(() => {
    if (selectedInboxItem) {
      setUrl(`/popupWindow/${selectedInboxItem.window_id}/${selectedInboxItem.record_id}`);
      // Create a temporary DOM element to parse the HTML content
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = selectedInboxItem.message;

      // Extract all <strong> elements and their corresponding text values
      const strongElements = tempDiv.querySelectorAll('strong');
      const dynamicColumns = [];
      const dynamicData = {};

      Array.from(strongElements).forEach((el, index) => {
        const label = el.innerText.replace(':', '').trim();
        const value = el.nextSibling?.nodeValue?.trim() || '';

        // Add each label as a dynamic column
        dynamicColumns.push({
          title: label,
          dataIndex: `column${index}`,
          key: `column${index}`,
        });

        // Map each value to its corresponding dynamic column
        dynamicData[`column${index}`] = value;
      });

      setTableColumns(dynamicColumns);
      setTableData([dynamicData]); // Set the table data with the extracted values

      // Replace <br> tags with newlines
      const messageWithBreaks = tempDiv.innerHTML.replace(/<br\s*\/?>/gi, '\n');
      const desiredPart = messageWithBreaks.split('<div><strong>')[0].replace(/\n/g, '<br/>');
      setMessageWithoutTable(desiredPart);

      const approvalState = selectedInboxItem?.approval_state ? JSON.parse(selectedInboxItem.approval_state) : {};

      // Ensure that approvalState is always an object
      const {
        previousState = '',
        currentState = '',
        nextState = ''
      } = approvalState || {};

      const steps = [
        previousState,
        currentState,
        nextState
      ].filter(Boolean); // Remove any null, undefined, or empty string values

      const currentStepIndex = steps.indexOf(currentState);

      setCurrentStep(currentStepIndex)
      // console.log(desiredPart);
      // Remove unwanted HTML elements like tables and strong
      // Array.from(tempDiv.querySelectorAll('table, strong')).forEach(el => el.remove());

      // // Replace remaining HTML tags with empty string and preserve newlines
      // const messageWithoutTable = tempDiv.innerHTML
      //   .replace(/<\/?[^>]+>/gi, '') // Remove remaining HTML tags
      //   .replace(/\s{2,}/g, ' ') // Replace multiple spaces with a single space
      //   .trim(); // Trim leading and trailing spaces

      // // Preserve line breaks
      // const finalMessage = messageWithoutTable.trim();

      // // Set the cleaned text content
      // console.log(finalMessage);
    }
  }, [selectedInboxItem, approvlData]);

  useEffect(() => {
    if (isProcessModalVisible) {
      setLoadingModal(true);
      const initialDisplayedData = {};
      let hasRecords = false;

      formLineFields.forEach((collaps) => {
        const columnData = processParamsData[collaps.column_name] || [];
        if (columnData.length > 0) hasRecords = true;
        initialDisplayedData[collaps.column_name] = columnData.slice(0, batchSize);
      });

      setDisplayedData(initialDisplayedData);
      if (hasRecords) {
        setTimeout(() => loadRemainingRecords(), 500);
      } else {
        setLoadingModal(false);
      }
    }
  }, [isProcessModalVisible, processParamsData]);

  const loadRemainingRecords = () => {
    formLineFields.forEach((collaps) => {
      const columnData = processParamsData[collaps.column_name] || [];
      const totalRecords = columnData.length;
      if (totalRecords > batchSize) {
        const remainingData = columnData.slice(batchSize);
        setTimeout(() => {
          setDisplayedData((prev) => ({
            ...prev,
            [collaps.column_name]: [...prev[collaps.column_name], ...remainingData]
          }));
          setLoadingModal(false);
        }, 500);
      } else {
        setLoadingModal(false);
      }
    });
  };

  useEffect(() => {
    const filteredData = {};
    formLineFields.forEach((collaps) => {
      const columnName = collaps.column_name;
      const searchInput = debouncedSearchInputs[columnName]?.toLowerCase() || "";
      const columnData = processParamsData[columnName] || [];

      if (!searchInput) {
        filteredData[columnName] = columnData.slice(0, batchSize);
      } else {
        filteredData[columnName] = columnData.filter((record) =>
          Object.values(record).some((value) =>
            String(value).toLowerCase().includes(searchInput)
          )
        );
      }
    });
    setDisplayedData(filteredData);
  }, [debouncedSearchInputs, processParamsData]);


  const handleMenuClick = ({ key }) => {
    setLoading(true);
    const selectedItem = approvlData.find(item => item.cwf_workflow_approvals_id === key);
    setSelectedInboxItem(selectedItem);
    setSelectedMenu(key)
    setTimeout(() => setLoading(false), 500); // Simulate loading time
  };

  const renderSkeleton = () => (
    <Card style={{ padding: "1%" }}>
      <Skeleton active title={false} paragraph={{ rows: 1, width: '50%' }} />
      <Skeleton.Input style={{ width: '70%', marginTop: 16 }} active />
      <div style={{ padding: '2% 2% 0 2%', fontSize: '12px', fontWeight: 400 }}>
        <Skeleton paragraph={{ rows: 3 }} active />
      </div>
      <Skeleton.Button style={{ width: 120, marginTop: 16 }} active />
      <Skeleton.Button style={{ width: 120, marginLeft: 8, marginTop: 16 }} active />
      <Skeleton.Button style={{ width: 160, marginLeft: 8, marginTop: 16 }} active />
      <Skeleton.Input style={{ width: '45%', marginTop: 24 }} active />
    </Card>
  );

  const onApprove = async () => {
    if (selectedInboxItem.show_process_popup === 'Y') {
      fetchProcessData();
    } else {
      executeApproval();
    }
  }

  const fetchProcessData = async () => {
    setLoadingProcess(true);
    try {
      const processId = selectedInboxItem.process_id || selectedInboxItem.record_id; // Use record_id as fallback if process_id is missing, or check where it is stored
      // The user request shows processId: "9ED91190EBB24E8BB319755FC3D4A43D" which matches process_id in the example object
      const pid = selectedInboxItem.process_id;
      const btnProcessData = await getProcessParamJson(null, null, pid);
      console.log(btnProcessData)
      if (btnProcessData) {
        let parameterArray = [];
        let parameterArrayForGrid = [];
        let params = btnProcessData.parameters || [];
        for (let i = 0; i < params.length; i += 1) {
          if (params[i].type === "Form") {
            parameterArrayForGrid.push(params[i]);
          } else {
            parameterArray.push(params[i]);
          }
        }
        setProcessTitle(btnProcessData.name);
        for (let index = 0; index < parameterArray.length; index++) {
          parameterArray[index]["ad_field_id"] = parameterArray[index].column_name;
          parameterArray[index]["isreadonly"] = parameterArray[index].readonly;
          parameterArray[index]["column_type"] = parameterArray[index].type;
          parameterArray[index]["name"] = parameterArray[index].display_name;
        }

        setProcessParams(parameterArray);
        setFormLineFields(parameterArrayForGrid);

        const processBtnFormData = await getProcessParamData(
          selectedInboxItem.window_id,
          selectedInboxItem.tab_id,
          selectedInboxItem.record_id,
          pid,
          null
        );
        setProcessParamsData(processBtnFormData || {});
        setIsProcessModalVisible(true);
      }
    } catch (error) {
      message.error("Failed to load process parameters");
    } finally {
      setLoadingProcess(false);
    }
  }

  const executeApproval = async (parameters = null) => {
    setLoading(true)
    const sanitizedComment = (commentText || "").replace(/\n/g, ' ');
    let approved = await getapproved(selectedInboxItem.cwf_workflow_approvals_id, sanitizedComment, parameters);

    if (approved && approved.messageCode === '200') {
      message.success(approved.message)
      const approvals = await getApprovals();
      const approvalsData = JSON.parse(approvals);
      const workflowDetails = approvalsData["workflow_details - "];

      setApprovlData(workflowDetails);
      const nextItem = workflowDetails.find(item => item.cwf_workflow_approvals_id === selectedMenu) || workflowDetails[0];
      setSelectedInboxItem(nextItem)
      setSelectedMenu(nextItem?.cwf_workflow_approvals_id)
      setLoading(false)
      setCommentText("")
      setIsProcessModalVisible(false);
    } else {
      setLoading(false)
      message.error(approved ? approved.message : "Approval failed");
    }
  }

  const handleProcessOk = () => {
    form.validateFields().then(values => {
      onProcessFinish(values);
    }).catch(info => {
      console.log('Validate Failed:', info);
    });
  };

  const checkProcessDisplayLogic = (field) => {
    if (field?.displaylogic) {
      let string = field.displaylogic;
      const matches = string.match(/@([^@]+)@/g);
      const keys = matches ? matches.map(match => match.slice(1, -1)) : [];
      const values = form.getFieldsValue();
      const userData = JSON.parse(localStorage.getItem("userData"));
      const country = userData?.country_iden;

      keys.forEach((k) => {
        if (k === "#Country") {
          string = string.replaceAll("@" + k + "@", `'${country}'`);
          return;
        }

        let actualDataValue = values[k] !== undefined ? values[k] : processParamsData[k];
        if (typeof actualDataValue === "string" && isNaN(actualDataValue)) {
          actualDataValue = `'${actualDataValue}'`;
        }
        if (typeof actualDataValue === "boolean") {
          actualDataValue = actualDataValue ? `'Y'` : `'N'`;
        }
        string = string.replaceAll("@" + k + "@", actualDataValue);
      });

      string = string.replaceAll("=", "==").replaceAll("<==", "<=").replaceAll(">==", ">=")
        .replaceAll("&", "&&").replaceAll("|", "||").replaceAll("====", "===")
        .replaceAll("&&&&", "&&").replaceAll("||||", "||");

      try {
        return eval(string);
      } catch (error) {
        return false;
      }
    }
    return true;
  };

  const handleSave = (row, tableName) => {
    const newData = [...processParamsData[tableName]];
    const index = newData.findIndex((item) => row.key === item.key);
    const item = newData[index];
    newData.splice(index, 1, { ...item, ...row });
    setProcessParamsData({ ...processParamsData, [tableName]: newData });
  };

  const handleSearchChangeForTable = (value, columnName) => {
    setSearchInputs((prev) => ({ ...prev, [columnName]: value }));
  };

  const handleReset = (clearFilters) => {
    clearFilters();
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Space style={{ marginBottom: '5px' }}>
          <Button onClick={() => handleReset(clearFilters)} size="small">Reset</Button>
          <Button
            onClick={() => {
              confirm({ closeDropdown: true });
              handleReset(clearFilters)
            }}
            size="small"
          >Ok</Button>
        </Space>
        <br />
        <Input
          value={selectedKeys[0]}
          onChange={e => { setSelectedKeys(e.target.value ? [e.target.value] : []) }}
          style={{ marginBottom: 3, width: 200 }}
        />
      </div>
    ),
    onFilter: (value, record) =>
      record[dataIndex] ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()) : '',
  });

  const onProcessFinish = async (values) => {
    setLoadingProcess(true);
    // Sanitize values
    Object.entries(values).forEach(([key, value]) => {
      if (value === true) values[key] = "Y";
      else if (value === false) values[key] = "N";
      else if (typeof value === "number") values[key] = `${value}`;
      else if (dayjs.isDayjs(value)) values[key] = `${value.format("YYYY-MM-DD HH:mm:ss")}`;
      else if (value === "") values[key] = null;
      else if (value === undefined) values[key] = null;
    });

    let getAllTablesValues = {};
    Object.keys(processParamsData).forEach(function (key) {
      let valObj = processParamsData[key];
      if (typeof valObj === "object" && valObj !== null) {
        getAllTablesValues[key] = [...valObj];
      }
    });

    // Handle selected records
    Object.entries(selectedRecordsData).forEach(([paramkey, paramrows]) => {
      if (getAllTablesValues[paramkey]) {
        let newParamData = [];
        paramrows.forEach((key) => {
          const row = getAllTablesValues[paramkey][parseInt(key)];
          if (row) newParamData.push(row);
        });
        getAllTablesValues[paramkey] = newParamData;
      }
    });

    const completeData = { ...values, ...getAllTablesValues };
    const stringifiedParams = JSON.stringify(JSON.stringify(completeData));

    await executeApproval(stringifiedParams);
    setLoadingProcess(false);
  }

  const onReject = async () => {
    setLoading(true)
    let rejected = await getRejected(selectedInboxItem.cwf_workflow_approvals_id, commentText);
    console.log(rejected)
    if (rejected.messageCode === '200') {
      message.success(rejected.message)
      const approvals = await getApprovals();
      const approvalsData = JSON.parse(approvals); // Parse the JSON string
      const workflowDetails = approvalsData["workflow_details - "]; // Access the array with bracket notation

      // Set the data to state
      setApprovlData(workflowDetails);
      setSelectedInboxItem(workflowDetails[0])
      setSelectedMenu(workflowDetails[0]?.cwf_workflow_approvals_id)
      setLoading(false)
      setCommentText("")
    } else {
      setLoading(false)
      message.error(rejected.message)
    }
  }

  return (
    <Layout style={{ minHeight: '100vh', background: "#f3f4f5" }}>
      <Sider width={250} theme="light">
        <div style={{ padding: '16px' }}>
          <Title level={4}>Inbox</Title>
          <Input
            prefix={<SearchOutlined />}
            placeholder="Search"
            value={searchQuery}
            onChange={handleSearchChange}
          />
        </div>
        <Menu
          mode="inline"
          selectedKeys={selectedMenu}
          onClick={handleMenuClick}
        >
          {filteredApprovals?.map(item => (
            <Menu.Item
              style={{ height: "60px", padding: "10px 20px" }}
              key={item.cwf_workflow_approvals_id}
            >
              <span>{item.title}</span>
              {/* <span style={{ fontSize: '12px', color: '#999' }}>{item.initiated_at}</span> */}
              <span style={{ display: "flex", justifyContent: "space-between", marginBottom: '2px', lineHeight: "20px" }}>

                <span style={{ fontSize: '12px', color: '#999', marginTop: '2px' }}>{item.initiated_by}</span>
                <span style={{ fontSize: '12px', color: '#999' }}>{item.initiated_at}</span>
              </span>
            </Menu.Item>
          ))}
        </Menu>
      </Sider>
      <Layout>
        <Content style={{ padding: '0 0 10px 10px', backgroundColor: '#f3f4f5', fontFamily: "Inter" }}>
          {loading ? renderSkeleton() : (
            selectedInboxItem && (
              <Card style={{ padding: "1% 2%" }}>
                <Title level={4} style={{ fontSize: "20px", fontWeight: 600, marginBottom: 0 }}>
                  {selectedInboxItem.type === "Approval"
                    ? `Approval Required: ${selectedInboxItem.title}`
                    : selectedInboxItem.title}
                </Title>
                {/* <Text type="secondary" style={{fontSize:"11px",fontWeight:400}}>
                Nick Magovac to AS, Pranav, Santhosh, Dileep, Abraar, Vasanth, Vinutha, Avinash, Vishal, Santosh, Shaik
              </Text> */}
                {/* <div style={{ padding:"2%",fontSize:"12px",fontWeight:400 }}>
                <Text>Dear [Recipient's Name],</Text>
                <br />
                <br/>
                <Text style={{marginTop:"3vh"}}>
                  This is an automated notification requesting your approval for a new sales quotation. Below are the details:
                </Text>
              </div> */}
                {/* <Table style={{ width:"70%" }} size='small' columns={columns} dataSource={tabData} pagination={false} /> */}
                <div style={{ padding: '2%', fontSize: '12px', fontWeight: 400 }}>
                  <div dangerouslySetInnerHTML={{ __html: messageWithoutTable }} />
                </div>
                {tableColumns.length > 0 &&
                  (<Table
                    style={{ width: "70%", paddingLeft: "2%" }}
                    size='small'
                    columns={tableColumns}
                    dataSource={tableData}
                    pagination={false}
                  />)}
                <Link to={url} style={{ textDecoration: 'none' }}>
                  <a
                    href={url}
                    onClick={(e) => {
                      e.preventDefault(); // Prevent default link behavior
                      window.open(url, "Record View", "width=1000,height=700,left=210,top=120");
                    }}
                    style={{ padding: 0, margin: '1px 30% 0 0', float: 'right', display: 'inline-block' }}
                  >
                    View Document
                  </a>
                </Link>
                {/* <br />
                <br/> */}
                {selectedInboxItem.type === "Approval" ?
                  <>
                    <div style={{ margin: '22px 0', paddingLeft: "2%" }}>
                      <Text strong>Action Required:</Text> Please review and approve the document at your earliest convenience.
                    </div>
                    <Steps size='small' current={currentStep} style={{ marginTop: '30px', marginBottom: '35px', padding: "0 10% 0 2%" }}>
                      {JSON.parse(selectedInboxItem.approval_state).previousState ? <Step title={JSON.parse(selectedInboxItem.approval_state).previousState} /> : null}
                      <Step title={JSON.parse(selectedInboxItem.approval_state).currentState} />
                      <Step title={JSON.parse(selectedInboxItem.approval_state).nextState} />
                    </Steps>
                    <div style={{ marginBottom: '24px', paddingLeft: "2%" }}>
                      <Button disabled={loading} onClick={onApprove} style={{ marginRight: '8px', borderRadius: "4px", fontWeight: 700, background: "#0C173A", color: "#fff" }}>Approve</Button>
                      <Button disabled={loading} onClick={onReject} style={{ marginRight: '8px', borderRadius: "4px", fontWeight: 700, background: "#BB1010", color: "#fff" }}>Reject</Button>
                      {/* <Button style={{ marginRight: '8px', borderRadius: "4px", fontWeight: 700, background: "#F4AC21", color: "#fff" }}>Propose Review</Button> */}
                    </div>
                    <span style={{ fontSize: "13px", paddingLeft: "2%" }}>
                      Remarks (If Any)
                    </span>
                    <br />
                    <Input.TextArea onChange={(e) => { setCommentText(e.target.value) }} value={commentText} style={{ width: "45%", marginLeft: "2%" }} rows={4} />
                    <br /></> : null}
                {/* <div style={{fontSize:"12px"}}>
                <Text>Thank you for your cooperation.</Text>
                <br />
                <Text>Best regards,</Text>
                <br />
                <Text>CW Suite</Text>
              </div> */}
              </Card>
            )
          )}
        </Content>
      </Layout>
      <Modal
        title={processTitle}
        visible={isProcessModalVisible}
        onOk={handleProcessOk}
        onCancel={() => setIsProcessModalVisible(false)}
        width={1000}
        footer={[
          <Button key="back" onClick={() => setIsProcessModalVisible(false)}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" loading={loadingProcess} onClick={handleProcessOk}>
            Confirm
          </Button>,
        ]}
      >
        <Spin spinning={loadingProcess || loadingModal} indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}>
          {/* <Scrollbars style={{ height: "60vh" }} autoHeight autoHeightMax={"60vh"} universal thumbSize={90}> */}
          <Form form={form} layout="vertical" onValuesChange={() => setReload(!reload)}>
            <Row gutter={16}>
              {processParams.map((field, index) => {
                const shouldRender = checkProcessDisplayLogic(field) && field.displayed !== "N";
                return shouldRender ? (
                  <Col span={12} key={index}>
                    <ProcessField
                      field={field}
                      fieldData={processParamsData}
                      form={form}
                      windowId={selectedInboxItem?.window_id}
                      headerTabId={selectedInboxItem?.tab_id}
                      setProcessParamsData={setProcessParamsData}
                    />
                  </Col>
                ) : null;
              })}
            </Row>
            <div style={{ marginTop: 24 }}>
              {formLineFields.sort((a, b) => a.sequenceno - b.sequenceno).map((collaps) => {
                let processParamsTable = processParamsData[collaps.column_name];
                if (processParamsTable) {
                  processParamsTable.forEach((item, idx) => {
                    item["tableName"] = collaps.column_name;
                    item["key"] = idx.toString();
                  });
                }

                const tableColumns = [];
                const sortedFields = (collaps.fields || []).sort((a, b) => a.sequenceno - b.sequenceno);
                sortedFields.forEach((f, idx) => {
                  f["mainKey"] = idx;
                  if (f.displayed === "Y") {
                    tableColumns.push({
                      title: f.name,
                      dataIndex: f.type === "Selector" ? `${f.field_name}_iden` : f.field_name,
                      editable: f.readonly !== "Y",
                      typeCol: f.type === "Selector",
                      mainKey: idx,
                      ...(!f.readonly || f.readonly === "N" ? {} : getColumnSearchProps(f.type === "Selector" ? `${f.field_name}_iden` : f.field_name))
                    });
                  }
                });

                const finalColumns = tableColumns.map((col) => {
                  const colDataValues = sortedFields.find((sf) => sf.mainKey === col.mainKey);
                  if (!col.editable || colDataValues.readonly === "Y") {
                    return { ...col, colDataValues };
                  }
                  return {
                    ...col,
                    colDataValues,
                    onCell: (record, rowIndex) => ({
                      record,
                      rowIndex,
                      editable: col.editable,
                      dataIndex: col.dataIndex,
                      title: col.title,
                      colData: colDataValues,
                      handleSave: handleSave,
                      allCols: formLineFields
                    }),
                  };
                });

                return (
                  <div key={collaps.column_name} style={{ marginTop: 12, display: checkProcessDisplayLogic(collaps) ? "" : "none" }}>
                    <Collapse defaultActiveKey={['panel']}>
                      <Panel header={collaps.display_name} key="panel">
                        <Col span={8} style={{ marginBottom: 12 }}>
                          <Input
                            placeholder={`Search ${collaps.display_name}`}
                            value={searchInputs[collaps.column_name] || ""}
                            onChange={(e) => handleSearchChangeForTable(e.target.value, collaps.column_name)}
                          />
                        </Col>
                        <RecordTable
                          dataSource={displayedData[collaps.column_name] || []}
                          columns={finalColumns}
                          selectedRecordsData={selectedRecordsData}
                          setSelectedRecordsData={setSelectedRecordsData}
                          handleSave={handleSave}
                          propTableName={collaps.column_name}
                          addLineFlag={collaps.enableaddline}
                        />
                      </Panel>
                    </Collapse>
                  </div>
                );
              })}
            </div>
          </Form>
          {/* </Scrollbars> */}
        </Spin>
      </Modal>
    </Layout>
  );
};

export default ApprovalWorkflowUI;